import svg4everybody from 'svg4everybody';
import $ from 'jquery';

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import slick from "slick-carousel/slick/slick";
//import Inputmask from "inputmask/dist/jquery.inputmask.min";
import "magnific-popup"

import "bootstrap"

//import Dropzone from "dropzone";

window.$ = $;
window.jQuery = $;
window.gsap = gsap;



//$(".inputmask").inputmask({"mask": "+7 (999) 999-9999"});


gsap.registerPlugin(ScrollTrigger);

//let scrollableElement = document.body; //document.getElementById('scrollableElement');
let rocket = document.querySelector('.rocket');

if(rocket !== null){
    document.body.addEventListener('wheel', checkScrollDirection);

    function checkScrollDirection(event) {
        if (checkScrollDirectionIsUp(event)) {
            rocket.classList.add('rocket--up');
            rocket.classList.remove('rocket--down');
        } else {
            rocket.classList.add('rocket--down');
            rocket.classList.remove('rocket--up');
        }
    }
}

function checkScrollDirectionIsUp(event) {
    if (event.wheelDelta) {
        return event.wheelDelta > 0;
    }
    return event.deltaY < 0;
}

ScrollTrigger.matchMedia({
    "(min-width: 992px)" : function() {
        gsap.utils.toArray("section").forEach(section => {
            gsap.fromTo(section, {y: 100, opacity: 0}, {
                y: 0,
                opacity: 1,
                ease: "none",
                scrollTrigger: {
                    trigger: section,
                    start: "100px bottom",
                    end: "+=100",
                    scrub: true
                }
            });
        });

        gsap.from(".animCounter", {
            textContent: "0",
            duration: 1,
            ease: "power1.inOut",
            modifiers: {
                textContent: value => formatNumber(value, 0)
            },
            scrollTrigger: {
                trigger: ".digits",
                start: "100px 80%",
                end: "+=100",
                toggleActions: "play none restart reverse",
                markers: false
            }
        });



        function formatNumber(value, decimals) {
            let s = (+value).toLocaleString('en-US').split(".");
            return decimals ? s[0] + "." + ((s[1] || "") + "00000000").substr(0, decimals) : s[0];
        }


        gsap.to(".first-screen__image",{
            duration: 1,
            y: 0,
            opacity: 1
        });


        gsap.to(".digit",{
            scrollTrigger: {
                trigger: ".digits ",
                toggleActions: "play none none none",
                scrub: 1,
                end: "bottom bottom",
            },
            duration: 1,
            y: 0,
            stagger: 0.2,
            opacity: 1
        });

        gsap.to(".block-2__card",{
            scrollTrigger: {
                trigger: ".block-2",
                toggleActions: "play none none none",
                scrub: 1,
                end: "bottom bottom",
            },
            duration: 1,
            y: 0,
            stagger: 0.2,
            opacity: 1
        });

        gsap.to(".block-3__card",{
            scrollTrigger: {
                trigger: ".block-3",
                toggleActions: "play none none none",
                scrub: 1,
                end: "bottom bottom",
            },
            duration: 1,
            y: 0,
            stagger: 0.2,
            opacity: 1
        });

        gsap.to(".advant",{
            scrollTrigger: {
                trigger: ".advantage",
                toggleActions: "play none none none",
                scrub: 1,
                end: "bottom bottom",
            },
            duration: 1,
            y: 0,
            stagger: 0.2,
            opacity: 1
        });

        gsap.to(".about-program__image",{
            scrollTrigger: {
                trigger: ".about-program",
                toggleActions: "play none none none",
                scrub: 1,
                end: "bottom bottom",
            },
            duration: 1,
            y: 0,
            opacity: 1
        });


        gsap.to(".about-program__content",{
            scrollTrigger: {
                trigger: ".about-program",
                toggleActions: "play none none none",
                scrub: 1,
                end: "bottom bottom",
            },
            duration: 1,
            y: 0,
            opacity: 1
        });


        gsap.to(".team__item",{
            scrollTrigger: {
                trigger: ".team",
                toggleActions: "play none none none",
                scrub: 1,
                end: "bottom bottom",
            },
            duration: 1,
            y: 0,
            stagger: 0.2,
            opacity: 1
        });


        gsap.to(".news",{
            scrollTrigger: {
                trigger: ".news-block ",
                toggleActions: "play none none none",
                scrub: 1,
                end: "bottom bottom",
            },
            duration: 1,
            stagger: 0.4,
            opacity: 1,
            delay: 2
        });

        gsap.to(".planet--top",{
            scrollTrigger: {
                trigger: ".timeline__container",
                toggleActions: "play none none none",
                scrub: 1,
                start: "0% 0%",
                end: "bottom bottom",
            },
            duration: 1.5,
            scale: 0,
            // stagger: 0.2
        });

        gsap.to(".planet--btm",{
            scrollTrigger: {
                trigger: ".timeline__container",
                toggleActions: "play none none none",
                scrub: 1,
                start: "0% 0%",
                end: "bottom bottom",
            },
            duration: 1.5,
            scale: 2,
            // stagger: 0.2
        });
        gsap.to(".tml-card-finish",{
            scrollTrigger: {
                trigger: ".timeline__finish-block",
                toggleActions: "play none none none",
                scrub: 1,
                start: "50% 50%",
                end: "1000% 100%",
                //markers: true,
                onEnter: function(){
                    if(rocket!==null) rocket.classList.add('is-end')
                },
                onLeave: function(){
                    if(rocket!==null) rocket.classList.remove('is-end')
                },
                onEnterBack: function(){
                    if(rocket!==null) rocket.classList.add('is-end')
                },
                onLeaveBack: function(){
                    if(rocket!==null) rocket.classList.remove('is-end')
                },

            },
            duration: 1.5,

            // stagger: 0.2
        });

        //const timelineTitle = document.querySelectorAll('.timeline__subtitle');

        const timelineBlock = gsap.utils.toArray(".timeline__block");
        timelineBlock.forEach(timelineBlock => {
            gsap.to('.timeline__subtitle',{
                scrollTrigger: {
                    trigger: timelineBlock,
                    toggleActions: "play none none none",
                    scrub: 1,
                    start: "0% 0%",
                    end: "bottom 1%",
                    //markers: true,
                    toggleClass: "is-active"

                },
                duration: 1.5,

                // stagger: 0.2
            });
        });

        function paralax(bottom = false, start = '-=50% top', end = 'bottom') {
            const paralaxWrapper = Array.from(document.querySelectorAll('.paralaxSection')).map(function(el) {
                const arr = Array.from(el.querySelectorAll('.paralaxEl')).map(function (item) {
                    const tl = gsap.timeline();
                    ScrollTrigger.create({
                        animation: tl,
                        trigger: el,
                        start: start,
                        end: end,
                        scrub: 2,
                        ease: 'none',
                        // markers: true,
                    })
                    tl.to(item, {
                        y: (target) => ((bottom ? el.offsetHeight : false) || -el.offsetHeight) * (item.dataset.ratio || 0.2),
                    });
                })
            });
        }
        paralax();
    }
})


svg4everybody();


$(document).ready(function() {
    "use strict";

    $(window).scroll(function(e){
        var $el = $('.sticky');
        if ($(this).scrollTop() > 600){
            $el.addClass('is-sticky');
        }
        if ($(this).scrollTop() < 600){
            $el.removeClass('is-sticky');
        }
    });


    $(".header__menu").click(function() {
        $(".header__menu").toggleClass("is-active");
        $(".header__nav").slideToggle();
    });

    $(".btnmenu").click(function() {
        $(this).toggleClass("is-active");
        $(".header2__nav").toggle();
    });


    $('.project-targets-slider').slick({
        dots: false,
        speed: 1000,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        variableWidth: true,
        prevArrow: '<button type="button" class="btn-slider prev"><img src="/images/sprites/svg/left.svg"></button>',
        nextArrow: '<button type="button" class="btn-slider next"><img src="/images/sprites/svg/right.svg"></button>',
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    variableWidth: false,
                }
            }
        ]
    });

    $('.partners-slider').slick({
        dots: false,
        speed: 1000,
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 2000,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            }
        ]
    });




    $('.reviews').slick({
        dots: false,
        speed: 1000,
        infinite: true,
        slidesToShow: 6,
        slidesToScroll: 6,
        arrows: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    vertical: false,
                    variableWidth: true
                }
            }
        ]
    });

    /*Magnific модальное окно */
    if($('.popup-with-form').length > 0){
        $('.popup-with-form').magnificPopup({
            type: 'inline',
            preloader: false,
            focus: '#name',
            mainClass: 'mfp-fade',
            callbacks: {
                beforeOpen: function() {
                    if($(window).width() < 700) {
                        this.st.focus = false;
                    } else {
                        this.st.focus = '#name';
                    }
                }
            }
        });
    }

    if($('.modal-popup').length > 0){
        $('.modal-popup').magnificPopup({
            type: 'inline',
            preloader: false,
            focus: 'input[type="text"]',
            mainClass: 'mfp-fade'
        });
    }


    $(".steps__wrapper .tab_item").not(":first").hide();
    $(".steps__wrapper .tab").click(function() {
        $(".steps__wrapper .tab").removeClass("active").eq($(this).index()).addClass("active");
        $(".steps__wrapper .tab_item").hide().eq($(this).index()).fadeIn()
    }).eq(0).addClass("active");







    $(".scroll").on("click","a", function (event) {
        // исключаем стандартную реакцию браузера
        event.preventDefault();

        // получем идентификатор блока из атрибута href
        var id  = $(this).attr('data-scroll-to'),

            // находим высоту, на которой расположен блок
            top = $(id).offset().top;

        // анимируем переход к блоку, время: 800 мс
        $('body,html').animate({scrollTop: top}, 800);
    });


    /*Magnific галерея*/
    if($('.popup-gallery').length > 0){
        $('.popup-gallery').magnificPopup({
            delegate: 'a',
            type: 'image',
            tLoading: 'Загрузка изображения #%curr%...',
            mainClass: 'mfp-fade mfp-img-mobile',
            gallery: {
                enabled: true,
                navigateByImgClick: true,
                preload: [0,1] // Will preload 0 - before current, and 1 after the current image
            },
            image: {
                tError: '<a href="%url%">Изображение #%curr%</a> не загружено.',
                titleSrc: function(item) {
                    return '';
                }
            }
        });
    }



    /*$(document).on('afterValidate', 'form.form', function (event, messages, errors) {
        $(this).find('button[type=submit]').attr('disabled', 'disabled');
        if(errors.length > 0) { return; }
        $(this).find('button[type=submit]').removeAttr('disabled');
    });*/

    $(document).on('click', '.register-popup-btn', function(){
        $.pjax({
            "url": $("#register-popup-pjax").data("url"),
            "push": false,
            "replace": false,
            "timeout": 10000,
            "scrollTo": false,
            "container": "#register-popup-pjax"
        });
        return false;
    });

    $(document).on('pjax:complete', '#register-popup-pjax', function(){
        $.magnificPopup.open({
            items: {
                src: '#register-popup-pjax'
            },
            type: 'inline',
            preloader: false,
            mainClass: 'mfp-fade',
            closeOnBgClick: false,
            callbacks: {
                close: function () {
                    $("#register-popup-pjax").html("");
                }
            }
        });
    });


    $(document).on('click', '.login-popup-btn', function(){
        $.pjax({
            "url": $("#login-popup-pjax").data("url"),
            "push": false,
            "replace": false,
            "timeout": 10000,
            "scrollTo": false,
            "container": "#login-popup-pjax"
        });
        return false;
    });

    $(document).on('pjax:complete', '#login-popup-pjax', function(){
        $.magnificPopup.open({
            items: {
                src: '#login-popup-pjax'
            },
            type: 'inline',
            preloader: false,
            mainClass: 'mfp-fade',
            closeOnBgClick: false,
            callbacks: {
                close: function () {
                    $("#login-popup-pjax").html("");
                }
            }
        });
    });


    $(document).on('click', '.forgot-pass-popup-btn', function(){
        $.pjax({
            "url": $("#forgot-pass-popup-pjax").data("url"),
            "push": false,
            "replace": false,
            "timeout": 10000,
            "scrollTo": false,
            "container": "#forgot-pass-popup-pjax"
        });
        return false;
    });

    $(document).on('pjax:complete', '#forgot-pass-popup-pjax', function(){
        $.magnificPopup.open({
            items: {
                src: '#forgot-pass-popup-pjax'
            },
            type: 'inline',
            preloader: false,
            mainClass: 'mfp-fade',
            closeOnBgClick: false,
            callbacks: {
                close: function () {
                    $("#forgot-pass-popup-pjax").html("");
                }
            }
        });
    });


    $(document).on('click', '.resend-mail-popup-btn', function(){
        $.pjax({
            "url": $("#resend-mail-popup-pjax").data("url"),
            "push": false,
            "replace": false,
            "timeout": 10000,
            "scrollTo": false,
            "container": "#resend-mail-popup-pjax"
        });
        return false;
    });

    $(document).on('pjax:complete', '#resend-mail-popup-pjax', function(){
        $.magnificPopup.open({
            items: {
                src: '#resend-mail-popup-pjax'
            },
            type: 'inline',
            preloader: false,
            mainClass: 'mfp-fade',
            closeOnBgClick: false,
            callbacks: {
                close: function () {
                    $("#resend-mail-popup-pjax").html("");
                }
            }
        });
    });

    $(document).on('click', '.validate-phone-popup-btn', function(){
        $.pjax({
            "url": $("#validate-phone-popup-pjax").data("url"),
            "push": false,
            "replace": false,
            "timeout": 10000,
            "scrollTo": false,
            "container": "#validate-phone-popup-pjax"
        });
        return false;
    });

    $(document).on('pjax:complete', '#validate-phone-popup-pjax', function(){
        $.magnificPopup.open({
            items: {
                src: '#validate-phone-popup-pjax'
            },
            type: 'inline',
            preloader: false,
            mainClass: 'mfp-fade',
            closeOnBgClick: false,
            callbacks: {
                close: function () {
                    $("#validate-phone-popup-pjax").html("");
                }
            }
        });
    });

    /*$(document).on('click', '.custom-file-upload', function(){
        $(this).find('INPUT[type=file]').trigger('click');
    });*/
    $(document).on('change', '.custom-file-upload input[type="file"]', function(){
        var value = $(this).val();
        $(this).prev('.file-name').text(value.replace("C:\\fakepath\\", ''));
        $(this).closest('.custom-file-upload').addClass('file-selected');
    });


    /*$(document).on('keydown', ".symbOnly",function(event){
        var r = /^[a-zA-Zа-яА-Я]+$/;
        if(event.key && event.key.length===1 && !r.test(event.key)){
            //if (event.keyCode >= 65 && event.keyCode <= 122){
            event.preventDefault();
            return false;
        }
    });
    $(document).on('keydown', ".rusSymbOnly",function(event){
        var r = /^[a-zA-Z0-9]+$/;
        if(event.key && event.key.length===1 && r.test(event.key)){
            //if (event.keyCode >= 65 && event.keyCode <= 122){
            event.preventDefault();
            return false;
        }
    });
    $(document).on('keydown', ".rusOnly",function(event){
        var r = /^[a-zA-Z]+$/;
        if(event.key && event.key.length===1 && r.test(event.key)){
            //if (event.keyCode >= 65 && event.keyCode <= 122){
            event.preventDefault();
            return false;
        }
    });
    $(document).on('keydown', ".latOnly",function(event){
        var r = /^[a-zA-Z_.@0-9]+$/;
        if(event.key && event.key.length===1 && !r.test(event.key)){
            event.preventDefault();
            return false;
        }
    });*/

    $(document).on('keydown', ".numOnly",function(event){
        var r = /^[0-9]+$/;
        if(event.key && event.key.length===1 && !r.test(event.key)){
            event.preventDefault();
            return false;
        }

    });

    $(document).on('keyup', ".mfp-wrap input[type='tel'], .page-content input[type='tel']", function(){//.attr("placeholder", "+7 (***) *** ** **")
        var val = this.value.replace(/\+7(.*)/g,'$1').replace(/\D/g, '');
        //if(val.length > 0 && val.substr(0,1)=='7'){ val = val.substr(1); }
        var newVal = '+7 (';
        if (val.length > 3) {
            newVal += val.substr(0, 3) + ') '; val = val.substr(3);
            if (val.length > 3) {
                newVal += val.substr(0, 3) + ' '; val = val.substr(3);
                if (val.length > 2) {
                    newVal += val.substr(0, 2) + ' '; val = val.substr(2);
                    newVal += val.substr(0,2);
                }else{
                    newVal += val.substr(0,2);
                }
            }else{
                newVal += val.substr(0,3);
            }
        }else{
            newVal += val.substr(0,3);
        }

        this.value = val?newVal:val;
    }).keyup();


    $(document).on('click', '.mfp-ready .cancel-btn', function(){
        $.magnificPopup.close();
        return false;
    });

    $(document).on('keyup', '.charcount', function(){
        var name = $(this).attr('id'),
            len = $(this).val().replace(/\r(?!\n)|\n(?!\r)/g, "\r\n").length,
            max_len = $(this).attr("maxlength"),
            show_el = $("#"+name+"_chCount"),
            str = char_count_template;

        str = str.replace("{used}", len);
        str = str.replace("{all}", max_len);

        if(show_el.length<=0){
            $(this).after("<div id='"+name+"_chCount' class='chars-count'>"+str+"</div>");
            //$().after();
        }else{
            show_el.text(str);
        }
        //$('#show').val()
    });

    $(".appl-stages__tab-content").not(":first").hide();
    $(".appl-stages__tab").click(function() {
        $(" .appl-stages__tab ").removeClass("active").eq($(this).index()).addClass("active");
        $(".appl-stages__tab-content ").hide().eq($(this).index()).fadeIn()
    }).eq(0).addClass("active");

    $('.appl-what-get-slider').slick({
        dots: false,
        speed: 1000,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        variableWidth: true,
        prevArrow: '<button type="button" class="btn-slider prev"><img src="/images/sprites/svg/left.svg"></button>',
        nextArrow: '<button type="button" class="btn-slider next"><img src="/images/sprites/svg/right.svg"></button>',
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    variableWidth: false,
                }
            }
        ]
    });

    $(".notification_message").delay(5000).fadeOut(400);

    $('.i-slider ').slick({
        dots: true,
        speed: 1000,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        cssEase: 'linear',
        prevArrow: '<button type="button" class="btn-slider prev"><img src="/images/sprites/svg/left2.svg"></button>',
        nextArrow: '<button type="button" class="btn-slider next"><img src="/images/sprites/svg/right2.svg"></button>',
        // autoplay: true,
        // autoplaySpeed: 2000,
    });

    $(".i-block-11__item").not(":first").hide();
    $(".path__tab").click(function() {
        $(".path__tab").removeClass("active").eq($(this).index()).addClass("active");
        $(".i-block-11__item").hide().eq($(this).index()).fadeIn()
    }).eq(0).addClass("active");

    // Функция для переключения вкладок
    function changeTab(next = true) {
        let currentIdx = $('.path__tab.active').index(); // Текущий индекс активной вкладки
        let nextIdx = next ? currentIdx + 1 : currentIdx - 1;
        let totalTabs = $('.path__tab').length;

        // Если достигли конца или начала списка, переходим на противоположный конец
        if (nextIdx >= totalTabs) {
            nextIdx = 0;
        } else if (nextIdx < 0) {
            nextIdx = totalTabs - 1;
        }

        $('.path__tab').eq(nextIdx).click(); // Эмулируем клик по следующей или предыдущей вкладке
    }

    setInterval(() => {
        changeTab()
    }, 20000)

    // Обработчик события для кнопки "Следующий"
    $('#path-tab-next').click(function() {
        changeTab(true);
    });

    // Обработчик события для кнопки "Предыдущий"
    $('#path-tab-prev').click(function() {
        changeTab(false);
    });

    $(".accordeon dd").hide().prev().click(function() {
        if(this.classList.value === 'active') {
            $(this).parents(".accordeon").find("dd").not(this).hide().prev().removeClass("active");
        }
        else {
            $(this).parents(".accordeon").find("dd").not(this).hide().prev().removeClass("active");
            $(this).next().not(":visible").show().prev().addClass("active");
        }
    });
});


(function () {
    const input = document.querySelectorAll(".form__input");

    input.forEach(element => {
            element.addEventListener("change", () => {
                if (element.value !== "") {
                    if (!element.classList.contains("filled")) {
                        element.classList.add("filled");
                    }
                } else {
                    element.classList.remove("filled");

                }
            });
        }
    );
}());

(function () {
    const second = 1000,
        minute = second * 60,
        hour = minute * 60,
        day = hour * 24,
        countdownDate = $("#countdown").data('countdown-date'),
        countDown = Date.parse(countdownDate),
        countdownInterval = setInterval(function() {
            const now = new Date().getTime(),
                distance = countDown - now,
                countdownEl = document.getElementById("countdown");

            if(countdownEl === null){ return; }

            if(distance>0){
                document.getElementById("days").innerText = Math.floor(distance / (day));
                document.getElementById("hours").innerText = Math.floor((distance % (day)) / (hour));
                document.getElementById("minutes").innerText = Math.floor((distance % (hour)) / (minute));
                document.getElementById("seconds").innerText = Math.floor((distance % (minute)) / second);
            }else{
                document.getElementById("days").innerText = 0;
                document.getElementById("hours").innerText = 0;
                document.getElementById("minutes").innerText = 0;
                document.getElementById("seconds").innerText = 0;

                clearInterval(countdownInterval);
            }

            /*//do something later when date is reached
            if (distance < 0) {
                countdown.style.display = "none";
                clearInterval(x);
            }*/
            //seconds
        }, 500);
}());
